module.exports = __webpack_public_path__ + "static/media/eva.8969341b.jpg";